import React from "ES/lib/react";
import _ from "ES/lib/lodash";
import Ledger from "./Ledger";
import esUtils from "ES/utils/esUtils";
import ModalWrap from "../../widgets/ModalWrap";
import ModalDialog from "../../widgets/ModalDialog";
import getLedgerData from "./getLedgerData";
import getOfferStatusForJob, {OFFER_STATII} from "../../../utils/getOfferStatusForJob";
import getBuyerNameCompany from "../../../utils/getBuyerNameCompany";
import getBuyerFirstName from "../../../utils/getBuyerFirstName";

let AuthedUserSession = require("../../../utils/AuthedUserSession");
let DateRange = require("ES/widgets/DateRange");

require("./ViewAgreement.less");

export default React.createClass({
    getInitialState: function () {
        return {
            show_ledger: false
        };
    },
    __toggleLedger: esUtils.wrapPreventDefault(function () {
        this.setState({
            show_ledger: !this.state.show_ledger
        });
    }),
    render: function () {
        let {
                event,
                Displaylists,
                mp_agreement
            } = this.props;
        let {show_ledger} = this.state;
        let modal;
        let sid = _.first(event.sids);
        let event_time = null;
        let event_venue = null;
        let display_payments = _.get(this.props, "display_payments", false);


        if (event.starttime || event.stoptime) {
            event_time = DateRange({start: event.starttime, start_format: "dddd, mmmm d, yyyy", stop: event.stoptime});
        } else {
            event_time = <div>
                <span className="DateRange fa fa-calendar"> (no stagetimes)</span>
            </div>;
        }

        let venue = _.first(event.Venue);

        if (event.deliveryMethod === 1 && !_.isEmpty(venue)) {
            event_venue = <div>
                <i className="fa fa-map-marker text-muted"/>
                {" "}
                {esUtils.venue_to_string(venue)}
            </div>;

        } else {
            event_venue = <div>
                {_.map(_.filter(Displaylists && Displaylists.universal && Displaylists.universal.deliverymethods, function (dm) {
                    return dm.id == event.deliveryMethod;
                }), "description").join(", ")
                }
            </div>;
        }

        if (show_ledger) {
            modal = <ModalDialog
                title="Payout to you"
                onClose={this.__toggleLedger}
            >
                <Ledger
                    event={event}
                    Displaylists={Displaylists}
                    mp_agreement={mp_agreement}
                    display_payments={display_payments}
                />
            </ModalDialog>;
        }

        let {grand_total, fee_speaking} = getLedgerData({
            event,
            Displaylists,
            mp_agreement
        });
        let offer_status = getOfferStatusForJob.statusForEvent(event, sid, false);
        let section_title = (_.indexOf(OFFER_STATII, offer_status) >= _.indexOf(OFFER_STATII, "offer accepted")) ? "Contract" : "Offer";
        let buyer_name = (_.indexOf(OFFER_STATII, offer_status) >= _.indexOf(OFFER_STATII, "offer accepted")) ? getBuyerNameCompany(event) : getBuyerFirstName(event);
        let contract_link_text = (mp_agreement.is_contract_custom) ? "Custom uploaded agreement (PDF) " : "Standard engagement agreement ";
        let showprintlink = false && (_.indexOf(OFFER_STATII, offer_status) >= _.indexOf(OFFER_STATII, "offer accepted")); //disabled until complete

        return <div className="agreement">
            <h2>{section_title}</h2>
            <div className="row">
                <div className="col-sm-4 text-right lbl">Client</div>
                <div className="col-sm-8 value">{buyer_name}</div>
            </div>
            <div className="row">
                <div className="col-sm-4 text-right lbl">Event</div>
                <div className="col-sm-8 value">{event.organization}</div>
            </div>
            <div className="row">
                <div className="col-sm-4 text-right lbl">Date</div>
                <div className="col-sm-8 value">{event_time}</div>
            </div>
            <div className="row">
                <div className="col-sm-4 text-right lbl">Location</div>
                <div className="col-sm-8 value">{event_venue}</div>
            </div>
            <div className="row" style={{marginTop: "3em"}}>
                <div className="col-sm-4 text-right lbl">Contracted Speaking Fee</div>
                <div className="col-sm-8 value">USD ${esUtils.format_number(fee_speaking, 2)}</div>
            </div>
            <div className="row">
                <div className="col-sm-4 text-right lbl">Payout To You</div>
                <div className="col-sm-8 value">USD ${esUtils.format_number(grand_total, 2)}
                    {" "}<a href="#" onClick={this.__toggleLedger}>
                        view details
                    </a>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-4 text-right lbl">Terms</div>
                <div className="col-sm-8 value preserve-whitespace">{mp_agreement.terms}</div>
            </div>
            <div className="row">
                <div className="col-sm-4 text-right lbl">Agreement Document</div>
                <div className="col-sm-8 value">{contract_link_text}
                    <a href={mp_agreement.contract_url} target="_blank">view{" "}<i className="fa fa-external-link"></i></a></div>
            </div>
            {showprintlink && <div className="row" style={{marginTop: "3em"}}>
                <div className="col-sm-8 col-sm-offset-4">
                    <a href={"/marketplace/event/printinvoice/" + event.eid + "?speaker_id=" + event.eid + "&token=" + AuthedUserSession.MY_USERNAME} target="_blank">print contract <i className="fa fa-external-link"></i></a>
                </div>
            </div>
            }

            {modal && <ModalWrap body={modal}/>}
        </div>
            ;
    }
});



// WEBPACK FOOTER //
// ./src/components/marketplace/MyLeadsTab/ViewAgreement.js